"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _decorators = require("decorators");

var _AccountList = require("./AccountList");

var _momentTimezone = babelHelpers.interopRequireDefault(require("moment-timezone"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var EventTimeAcceptedItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(EventTimeAcceptedItem, _Component);

  function EventTimeAcceptedItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, EventTimeAcceptedItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(EventTimeAcceptedItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "selected", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(EventTimeAcceptedItem, [{
    key: "render",
    value: function render() {
      var d = _momentTimezone.default.tz(this.item.startingAt, _momentTimezone.default.tz.guess()); // <Person> has accepted the proposed event time for <EventTitle>. Please enter an event link to finalize the schedule.


      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        selected: this.selected,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "success",
        overlay: "date_range"
      }, _react.default.createElement(_AccountList.Account, {
        account: this.item.person
      }), ' has accepted the proposed event time for ', _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), this.item.course && ' on ', this.item.course && _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.course.title), '. Please enter an event link to finalize the schedule.');
    }
  }], [{
    key: "notificationObject",
    value: function notificationObject(_ref) {
      var _this2 = this;

      var item = _ref.item;
      return Promise.all([_List.NotificationItem.notificationObject({
        item: item,
        overlayType: 'success',
        overlay: 'date_range'
      })]).then(function (_ref2) {
        var _ref3 = babelHelpers.slicedToArray(_ref2, 1),
            notificationObject = _ref3[0];

        var d = _momentTimezone.default.tz(_this2.item.startingAt, _momentTimezone.default.tz.guess());

        return Object.assign(notificationObject, {
          body: [item.person.name, ' has accepted the proposed event time for ', item.catalogItem.title, item.course ? " on {item.course.title}" : '', '. Please enter an event link to finalize the schedule.'].join(' ').split(/\s+/g).filter(function (v) {
            return !!v;
          }).join(' ')
        });
      });
    }
  }]);
  return EventTimeAcceptedItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "selected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
exports.default = EventTimeAcceptedItem;